import dayjs from 'dayjs'
import baseJs from './base'

export const replyStateList = {
  0: '未読',
  1: '既読',
  2: '返信済'
}
export const announcementStateList = {
  0: '公開中',
  1: '下書き',
  2: '公開終了',
  3: '予約'
}

/**
 * 画面表示用のデータ整形
 *
 * @param object announcement
 * @return object
 */
export function toDisplayAnnouncement(announcement) {
  if (!announcement) {
    announcement = getEmptyAnnouncementInfo()
  }
  const today = dayjs(new Date())

  if (announcement.ended_at) {
    const endedAt = dayjs(announcement.ended_at).format('YYYY年MM月DD日')
    announcement.display_ended_at = endedAt

    // 回答期限の3日以内かつ、未返信か
    const isBefore3day = dayjs(announcement.ended_at).diff(today, 'day', true) <= 3
    announcement.is_alert_ended = isBefore3day && Number(announcement.reply) === 0
  } else {
    announcement.display_ended_at = '無期限'
    announcement.is_alert_ended = false
  }

  announcement.display_notice_date = dayjs(announcement.updated_at).format('YYYY年MM月DD日')

  // オプション用の整形
  const options = []
  for (let i = 1; i <= 5; i++) {
    const replyOption = announcement['reply_option_' + i]
    if (!replyOption) {
      continue
    }
    options.push({
      value: i,
      text: replyOption
    })
  }

  return {
    ...announcement,
    options
  }
}

export function toArrangeAnnouncement(announcement) {
  announcement.publishing_status = announcement.is_draft

  // 公開期間を整形
  if (!announcement.started_at) {
    announcement.started_at = announcement.created_at
  }
  announcement.started_at = new Date(announcement.started_at)
  if (announcement.ended_at) {
    announcement.ended_at = new Date(announcement.ended_at)
  }
  if (announcement.is_draft === '0') {
    if (announcement.ended_at && announcement.ended_at < new Date()) {
      announcement.publishing_status = 2
      // 公開終了
    } else if (announcement.started_at && announcement.started_at > new Date()) {
      // 公開開始前なので予約
      announcement.publishing_status = 3
    }
  }
  return announcement
}

export function getEmptyAnnouncementInfo() {
  return {
    announcement_id: 0,
    user_id: 0,
    status: 0,
    title: '',
    body: '',
    is_draft: 1,
    created_at: null,
    updated_at: null,
    started_at: new Date(),
    ended_at: null,
    link: null,
    reply_option_1: '参加する',
    reply_option_2: '参加しない',
    reply_option_3: '検討中',
    to_user_ids: [],
    arrangedState: '',
    timer: 0
  }
}

export function getReplyText(announcementInfo, reply) {
  if (Number(reply) === 0) {
    return '未返信'
  }
  if (!announcementInfo['reply_option_' + reply]) {
    return '不明な回答'
  }
  return announcementInfo['reply_option_' + reply]
}

export function getReplyList(announcement) {
  const replyOptions = [{ text: '全て', value: 'all' }]
  if (!announcement) {
    return replyOptions
  }
  // 特定の返信の場合は、10 + reply_optionをvalueとする
  for (let index = 1; index <= 5; index++) {
    if (announcement['reply_option_' + index]) {
      replyOptions.push({ value: index, text: announcement['reply_option_' + index] })
    }
  }
  return replyOptions
}

export function getReplyOptions(announcement) {
  const replyOptions = [
    { value: 100, text: '全員' },
    { value: 0, text: '未読' },
    { value: 1, text: '既読' },
    { value: 2, text: '返信済' },
    { value: 3, text: '未返信' }
  ]
  if (!announcement) {
    return replyOptions
  }
  replyOptions.push({ value: null, text: '---', disabled: true })
  // 特定の返信の場合は、10 + reply_optionをvalueとする
  for (let index = 1; index <= 5; index++) {
    if (announcement['reply_option_' + index]) {
      replyOptions.push({ value: index + 10, text: announcement['reply_option_' + index] })
    }
  }
  return replyOptions
}

// 成果単体の情報を表示用にデータ整形
export function getArrangedAnnouncement(announcement) {
  announcement.publishing_status = announcement.is_draft
  announcement.replyText = getReplyText(announcement)

  // 公開期間を整形
  if (!announcement.started_at) {
    announcement.started_at = announcement.created_at
  }
  announcement.started_at = new Date(announcement.started_at)
  if (announcement.ended_at) {
    announcement.ended_at = new Date(announcement.ended_at)
  }
  if (announcement.is_draft === '0') {
    if (announcement.ended_at && announcement.ended_at < new Date()) {
      announcement.publishing_status = 2
      // 公開終了
    } else if (announcement.started_at && announcement.started_at > new Date()) {
      // 公開開始前なので予約
      announcement.publishing_status = 3
    }
  }
  return announcement
}

export function getAnnouncementFields(showAll) {
  const returnList = [
    { key: 'title', label: 'タイトル', sortable: showAll, textSearch: true },
    { key: 'body', label: '', hidden: true, textSearch: true },
    { key: 'status', label: '状態', hidden: true, selectSearch: baseJs.getSelectionsByObject(replyStateList, true) },
    { key: 'ended_at', label: '返信期限', sortable: showAll, dateSearch: true }
  ]
  if (showAll) {
    returnList.splice(3, 0, { key: 'started_at', label: '公開日', sortable: showAll, dateSearch: true })
  }
  return returnList
}

export function getAnnouncementFieldsForAdmin(showAll = false) {
  const returnList = [
    { key: 'title', label: 'タイトル', sortable: showAll, textSearch: true },
    { key: 'not_open_num', label: '未読', booleanSearch: true, sortable: showAll },
    { key: 'open_num', label: '既読', sortable: showAll },
    { key: 'reply_num', label: '返信数', booleanSearch: true, sortable: showAll }
  ]
  if (showAll) {
    returnList.splice(
      4,
      0,
      { key: 'body', label: '', hidden: true, textSearch: true },
      {
        key: 'publishing_status',
        label: '公開状態',
        sortable: showAll,
        hidden: true,
        selectSearch: baseJs.getSelectionsByObject(announcementStateList, true)
      },
      { key: 'started_at', label: '公開日', sortable: showAll, dateSearch: true },
      { key: 'ended_at', label: '公開終了日', sortable: showAll, dateSearch: true },
      { key: 'management', label: '操作' }
    )
  }
  return returnList
}
